import React, { Component } from "react";
import { history } from "components/App/components/UnauthenticatedApp";
import "./Login.module.scss";
import { connect } from "react-redux";

//import components
import DefaultButton from "components/UI/Button/Button";

import loginUser from "actions/authentication/login";

const mapDispatchToProps = {
    loginUser
};

class Login extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: "",
            password: ""
        };

        this.login = this.login.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    componentDidMount() {
        if (this.props.match.params.token) {
            //we have a temp login
            let token = this.props.match.params.token;
            if (token.includes("error:limit")) {
                alert(
                    "Uw organisatie heeft het maximaal aantal accounts bereikt. Neem contact op met app@plenda.nl!"
                );
            } else if (token.includes("error:organisation")) {
                alert(
                    "Voor deze organisatie is het nog niet mogelijk in te loggen via Microsoft. Neem contact op met app@plenda.nl!"
                );
            } else {
                this.login(this.props.match.params.token);
            }
        }
    }

    login(token) {
        this.props
            .loginUser(
                token
                    ? {
                          token: token
                      }
                    : this.state
            )
            .catch(error =>
                alert(
                    "Combinatie gebruikersnaam en wachtwoord onjuist, probeer opnieuw."
                )
            );
    }

    handleEmailChange(event) {
        this.setState({ email: event.target.value });
    }

    handlePasswordChange(event) {
        this.setState({ password: event.target.value });
    }

    goToRegister() {
        history.push("/activeer");
    }

    goToPasswordReset() {
        history.push("/wachtwoord/vergeten");
    }

    handleKeyDown(event) {
        if (event.key === "Enter") {
            this.login();
        }
    }

    render() {
        return (
            <div styleName="login-background">
                <div styleName="top-bar">
                    <img styleName="logo" src="/images/logos/plenda-logo.svg" />
                </div>
                <div styleName="content">
                    <img
                        styleName="mountains-logo"
                        src="/images/mountains.svg"
                    />
                    <form styleName="login-form">
                        <label styleName="input-label">Emailadres</label>
                        <input
                            value={this.state.email}
                            onChange={this.handleEmailChange}
                            styleName="input-box"
                            type="email"
                        />

                        <label styleName="input-label">Wachtwoord</label>
                        <input
                            value={this.state.password}
                            onChange={this.handlePasswordChange}
                            onKeyDown={this.handleKeyDown}
                            styleName="input-box"
                            type="password"
                        />
                    </form>
                    <div styleName="actions">
                        <div styleName="buttons">
                            <DefaultButton
                                textStyle={{ alignItems: "center" }}
                                handleClick={() => {
                                    history.push("/activeer");
                                }}
                                noarrow
                                style={{
                                    width: "100%",
                                    borderRadius: "3px",
                                    margin: "9px 10px 0 0"
                                }}
                                title="Registreren"
                            />
                            <DefaultButton
                                textStyle={{ alignItems: "center" }}
                                handleClick={this.login}
                                noarrow
                                style={{
                                    width: "100%",
                                    borderRadius: "3px",
                                    margin: "9px 0 0 10px"
                                }}
                                title="Login"
                                type="blue"
                            />
                        </div>
                        <a href="/auth/microsoft/login">
                            <img
                                styleName="microsoft"
                                src="/images/login-microsoft.svg"
                            />
                        </a>
                        <div styleName="text">
                            <p>Wachtwoord vergeten?</p>
                            <p
                                styleName="link"
                                onClick={this.goToPasswordReset}
                            >
                                Stel opnieuw in
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(null, mapDispatchToProps)(Login);
